import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "row"]
  
  connect() {
    // Initialize with empty search to handle any pre-filled search terms
    this.search()
  }
  
  disconnect() {
    clearTimeout(this.timeout)
  }
  
  // Debounce the search to improve performance
  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }
  
  performSearch() {
    const searchTerm = this.searchInputTarget.value.trim().toLowerCase()
    
    this.rowTargets.forEach(row => {
      // Get the symbol from the first cell's div
      const symbolDiv = row.querySelector('td:first-child div')
      const symbolText = symbolDiv ? symbolDiv.textContent.trim().toLowerCase() : ''
      
      // Get the name from the second cell's div (handling both link and plain text)
      const nameDiv = row.querySelector('td:nth-child(2) div')
      let nameText = ''
      if (nameDiv) {
        // If there's a link inside, get the link text, otherwise get the div text
        const linkElement = nameDiv.querySelector('a')
        nameText = linkElement ? 
          linkElement.textContent.trim().toLowerCase() : 
          nameDiv.textContent.trim().toLowerCase()
      }
      
      // Show row if search term is empty or matches symbol/name
      const matches = searchTerm === '' || 
                     symbolText.includes(searchTerm) || 
                     nameText.includes(searchTerm)
      
      row.style.display = matches ? '' : 'none'
    })
  }
}